import { handleActions } from 'redux-actions';
import {
    setUser,
    setRoles
} from '../actions/userActions';

const defaultState = {
    main:null,
    roles:null
};

export default handleActions(
  {
    [setUser](state, { payload }) {
        return {...state, main: payload};
    },[setRoles](state, { payload }) {
        return {...state, roles: payload};
    }
  },
  defaultState,
);
